import { ApprovalUserStatus, TApproval, TApprovalUser } from '../types';

export const getSignedApprovalUserIds = (users?: TApprovalUser[]) =>
  users
    ?.filter((approvalUser) => approvalUser.status === ApprovalUserStatus.ACCEPTED)
    .map((approvalUser) => approvalUser.user) || [];

const getUpdateApprovalDefaultValues = (approval?: TApproval) => ({
  authors: approval?.phases.AUTHORING?.users.map((u) => u.user) || [],
  reviewers: approval?.phases.REVIEWING?.users.map((u) => u.user) || [],
  approvers: approval?.phases.APPROVING?.users.map((u) => u.user) || [],
});

export default getUpdateApprovalDefaultValues;
